// extracted by mini-css-extract-plugin
module.exports = {"signHeaderToggle":"sign-header__toggle-0fa","signHeaderText":"sign-header__text-eed","signHeaderTextActive":"sign-header__text_active-26f"};